<template>
  <div>
    <input type='hidden' name='tag[color]' :value='tag.color' />

    <label class="col-form-label">
      {{$t('tags.color_picker.color')}}
    </label>

    <div class="color-picker-wrapper">
      <div v-for='color in colors' :class="['color-circle-wrapper', color, { active: tag.color === color }]" @click="assignColor(color)" :key='color'>
        <div class="color-circle"></div>

        <div class="selected-tag">
          {{$t('tags.color_picker.selected')}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['startingColor'],
    data() {
      return {
        color: null
      }
    },
    watch: {
      startingColor() {
        this.$props.startingColor && (this.color = this.$props.startingColor)
      }
    },
    computed: {
      tag() {
        return { color: this.color }
      },
      colors() {
        return [
          'blue',
          'purple',
          'light-blue',
          'red',
          'pink',
          'orange',
          'turquoise',
          'green',
          'yellow',
          'grey'
        ]
      }
    },
    methods: {
      assignColor(color) {
        this.color = color
      }
    }
  }
</script>

<style scoped>
  .color-picker-wrapper {
    width: 100%;
    overflow: auto;
    height: 60px;
    cursor: pointer;
  }

  .color-circle-wrapper {
    float: left;
    width: 38px;
    height: 38px;
    border-radius: 20px;
    margin-right: 4px;
    margin-left: 4px;
    cursor: pointer;
    position: relative;
  }

  .color-circle-wrapper .selected-tag {
    display: none;
  }

  .color-circle-wrapper.active .selected-tag {
    display: block;
    position: absolute;
    font-size: 11px;
    top: 40px;
  }

  .color-circle-wrapper .color-circle {
    float: left;
    width: 30px;
    height: 30px;
    border-radius: 20px;
    margin-top: 4px;
    margin-left: 4px;
  }

  .color-circle-wrapper.blue.active, .color-circle-wrapper.blue:hover {
    background: #D5E1FF;
  }
  .color-circle-wrapper.purple.active, .color-circle-wrapper.purple:hover {
    background: #E2E6FF;
  }
  .color-circle-wrapper.light-blue.active, .color-circle-wrapper.light-blue:hover {
    background: #EBF8FF;
  }
  .color-circle-wrapper.red.active, .color-circle-wrapper.red:hover {
    background: #FFE2E2;
  }
  .color-circle-wrapper.pink.active, .color-circle-wrapper.pink:hover {
    background: #FFEAED;
  }
  .color-circle-wrapper.orange.active, .color-circle-wrapper.orange:hover {
    background: #FFECE1;
  }
  .color-circle-wrapper.turquoise.active, .color-circle-wrapper.turquoise:hover {
    background: #E0F6F0;
  }
  .color-circle-wrapper.green.active, .color-circle-wrapper.green:hover {
    background: #E7FBE0;
  }
  .color-circle-wrapper.yellow.active, .color-circle-wrapper.yellow:hover {
    background: #FFFBCE;
  }
  .color-circle-wrapper.grey.active, .color-circle-wrapper.grey:hover {
    background: #F3F3F3;
  }

  .color-circle-wrapper.blue .color-circle {
    background: #7DA1FF;
  }
  .color-circle-wrapper.purple .color-circle {
    background: #A3B2FF;
  }
  .color-circle-wrapper.light-blue .color-circle {
    background: #B6E5FF;
  }
  .color-circle-wrapper.red .color-circle {
    background: #FF9898;
  }
  .color-circle-wrapper.pink .color-circle {
    background: #F7BBC5;
  }
  .color-circle-wrapper.orange .color-circle {
    background: #FFC4A3;
  }
  .color-circle-wrapper.turquoise .color-circle {
    background: #9DDECD;
  }
  .color-circle-wrapper.green .color-circle {
    background: #B4F39D;
  }
  .color-circle-wrapper.yellow .color-circle {
    background: #F0E77F;
  }
  .color-circle-wrapper.grey .color-circle {
    background: #D7D7D7;
  }
</style>
